import TooltipRenderer from '_legacy/components/grid/renderers/TooltipRenderer';
import BlanksFilterRenderer from '_legacy/components/grid/renderers/BlanksFilterRenderer';
import suppressOnEdit from '_legacy/components/grid/columnDefaults/suppressOnEdit';
import defaultObjEquals from '_legacy/components/grid/columnDefaults/defaultObjEquals';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import { isEditableRow } from '_legacy/modules/shared/columns/tools/headingTools';
import TceEditor from './TceEditor';
import { MultipleTceFormatter } from './formatters/MultipleTceFormatter';
import TceKeyCreator from './TceKeyCreator';
import TceComparator, { TceFilterComparator } from './TceComparator';

export const tceHeading = {
    colId: 'tceParts',
    headerName: 'TCE',
    field: 'tceParts',
    editable: isEditableRow,
    valueFormatter: MultipleTceFormatter,
    cellEditorFramework: TceEditor,
    cellRenderer: (tce) => TooltipRenderer({ value: tce.valueFormatted }),
    suppressKeyboardEvent: suppressOnEdit(),
    equals: defaultObjEquals,
    comparator: TceComparator,
    keyCreator: TceKeyCreator,
    width: 120,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: TceFilterComparator,
        showTooltips: true,
    },
};
